import React, { memo, useContext } from 'react'
import { format } from 'react-string-format'
import PropTypes from 'prop-types'
import UserContext from '../contexts/UserContext'
import { itemType } from '../types'
import Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import { processStatusConstants } from '../utils/fileSizeFunctions'

const AwsS3Multipart = require('@uppy/aws-s3-multipart')

const UPPY_RETRY_AFTER_IN_SEC = [0, 1000, 3000, 5000, 6000, 6000] // updated so closer to default
//const UPPY_RETRY_AFTER_IN_SEC = [0, 5000, 10000, 30000, 60000, 120000]
// info on retry delays https://uppy.io/docs/tus/

function FileUploadUppyModal(props) {
  let upload_file_dict = {}
  let fileListRawMessage = {}
  let { isOverwriteInfoSeen } = props
  const { item, itemFilesCount, fileUploadLimit, setShow, setUppyOpen, setReturnInputs, uploadLimitMessageHeader, uploadLimitMessage } = props
  const { username } = useContext(UserContext)
  let overWriteAlertHeader = 'This ScienceBase item currently has one or more files with the same filename attached. If you elect to upload the selected file(s), it will overwrite the current files(s). Proceed? \n'

  const handleCloseUppyModal = () => {
    uppy.cancelAll()
    const uppyState = uppy.getState()
    let displayModalMessageForLaterScraping = false
    for (const [, value] of Object.entries(uppyState.files)) {
      if (value?.progress?.uploadComplete) {
        displayModalMessageForLaterScraping = true
        setUppyOpen(false)
      }
    }
    setShow(displayModalMessageForLaterScraping)
    const dashboardModelPlugin = uppy.getPlugin('react:DashboardModal')
    console.log(dashboardModelPlugin.isModalOpen())
    if (dashboardModelPlugin && dashboardModelPlugin.isModalOpen()) {
      dashboardModelPlugin.closeModal()
    }
    setUppyOpen(false)
  }
  const uppy = new Uppy({
    id: 'sb-s3-multipart',
    autoProceed: false,
    debug: false,
    showProgressDetails: true,
    doneButtonHandler: null,
    hideUploadButton: true,
    locale: {
      strings: { closeModal: 'Close Modal and Stop Uploading', dropPasteFiles: 'Drop files here, paste or %{browse}. \n\n\nPlease note that files may take time to be processed after being uploaded and closing this upload dialogue box or the current browser tab will cancel the file upload(s).' }
    },
    meta: { username: username },
    onBeforeUpload: (files) => {
      let overwriteFileList = []
      fileListRawMessage = []
      uppy.hideInfo()
      uppy.getFiles().map(obj1 => {
        let index = obj1.name.lastIndexOf('/')
        let name = obj1.name.substring(index + 1)
        let matchedObj = item.fileConnection.files.find(obj2 => obj2.name === name)
        if (matchedObj) {
          overwriteFileList.push(name)
        }
      })

      console.log(`isOverwriteInfoSeen ${isOverwriteInfoSeen}`)

      if (overwriteFileList.length > 0) {
        fileListRawMessage = '\n' + overwriteFileList
          .filter(f1 => item.fileConnection.files.some(f2 => f1 === f2.name))
          .map(filename => filename)
          .join(', \n')
        let fileListMessage = fileListRawMessage.split('\n').map(i => i)

        console.log(`fileListRawMessage ${fileListRawMessage} \n fileListMessage ${fileListMessage}`)
        console.log(`Warning for overwrite files ${overwriteFileList}`)

        var alertMessage = `${overWriteAlertHeader} ${(fileListRawMessage)}`

        if (!isOverwriteInfoSeen) {
          uppy.info({
            message: alertMessage,
            details: ''
          }, 'error', 999999)
          isOverwriteInfoSeen = true
          return false
        }
      }

      var limit = fileUploadLimit - itemFilesCount
      console.log(`Object.keys(files).length ${Object.keys(files).length}, overwriteFileList.length ${overwriteFileList.length}`)
      console.log(`New files to be uploaded ${Object.keys(files).length - overwriteFileList.length}`)
      if ((Object.keys(files).length - overwriteFileList.length) > limit) {
        let alertMessage = format(uploadLimitMessage, limit)
        let alertHeader = `${uploadLimitMessageHeader} ${alertMessage}`
        uppy.info({
          message: alertHeader,
          details: ''
        }, 'error', 999999)
        return false
      }
    },
    onBeforeFileAdded: (currentFile, files) => {
      isOverwriteInfoSeen = false
      uppy.hideInfo()
      var modifiedFile = null
      if (currentFile.name.endsWith('.sd')) {
        modifiedFile = {
          ...currentFile,
          name: `${item.id}/` + currentFile.name,
          type: 'x-gis/x-arcgis-service-def'
        }
      }
      else {
        modifiedFile = {
          ...currentFile,
          name: `${item.id}/` + currentFile.name,
        }
      }
      return modifiedFile
    },
  })

  uppy
    .use(AwsS3Multipart, {
      companionUrl: `${process.env.REACT_APP_UPPY_COMPANION_SERVER}`,
      trigger: null,
    })
    .on('upload-error', (file, error, response) => {
      const currentRetryValue = upload_file_dict[file.id] ? upload_file_dict[file.id] : 0

      if (currentRetryValue < UPPY_RETRY_AFTER_IN_SEC.length) {
        setTimeout(function () {
          console.log('Retrying File :', file.id, 'retrying in', UPPY_RETRY_AFTER_IN_SEC[currentRetryValue])
          uppy.retryUpload(file.id)
        }, UPPY_RETRY_AFTER_IN_SEC[currentRetryValue])
        upload_file_dict[file.id] = currentRetryValue + 1
      }
    })
    .on('complete', (result) => {
      console.log(result)
      console.log(
        'Upload complete! We’ve uploaded these files:',
        result.successful)
      const successfulFiles = result.successful?.map(file => {
        isOverwriteInfoSeen = false
        return {
          name: file.data.name,
          key: file.name,
          lastUpdatedBy: username,
          size: String(file.size),
          contentType: file.type,
          lastModified: file.data.lastModifiedDate,
          processStatus: processStatusConstants.UPLOAD_SUCCESS,
        }
      })

      const failedFiles = result.failed?.map(file => {
        return {
          name: file.data.name,
          key: file.name,
          lastUpdatedBy: username,
          size: String(file.size),
          contentType: file.type,
          lastModified: file.data.lastModifiedDate,
          processStatus: processStatusConstants.UPLOAD_FAILED
        }
      })

      setReturnInputs([...successfulFiles, ...failedFiles])
    })
    .on('file-removed', (result) => {
      uppy.hideInfo()
      if (fileListRawMessage.length > 0) {
        let index = result.name.lastIndexOf('/')
        let name = result.name.substring(index + 1)
        fileListRawMessage = fileListRawMessage.replace(`${name},`, '').replace(`${name}`, '').replace('\n','')
        if (fileListRawMessage.trim().length > 0) {
          var alertMessage = `${overWriteAlertHeader} ${(fileListRawMessage)}`
          uppy.info({
            message: alertMessage,
            details: ''
          }, 'error', 999999)
          isOverwriteInfoSeen = true
          return false
        }
      }
    })


  return (
    <DashboardModal {...props} uppy={uppy} onRequestClose={handleCloseUppyModal} />
  )
}

FileUploadUppyModal.propTypes = {
  onHide: PropTypes.func,
  selectedRows: PropTypes.any,
  onClear: PropTypes.func,
  item: itemType,
  isOverwriteInfoSeen: PropTypes.bool,
  itemFilesCount: PropTypes.number,
  fileUploadLimit: PropTypes.number,
  uploadLimitMessageHeader: PropTypes.string,
  uploadLimitMessage: PropTypes.string,
  setShow: PropTypes.func,
  setUppyOpen: PropTypes.func,
  setReturnInputs: PropTypes.func

}

export default memo(FileUploadUppyModal)
